import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { searchReviews, fetchReviews } from "../../actions/reviewAction";
import {
  Popup,
  //Button,
} from "semantic-ui-react";
import { imageDomain, singleImageURL } from "../configC/keys";
import {
  formatDuration,
  intervalToDuration,
  // format,
} from "date-fns";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { RiImageAddLine } from "react-icons/ri";
import { FaSearch } from "react-icons/fa";
import Confirm from "../common/ConfirmGr";
import ModalGr from "../modalGr/Modal";
import { bgColor } from "../functions/Functions";
import ReviewCreate from "../create/ReviewCreate";
import ReviewEdit from "../create/ReviewEdit";
import ReviewSearch from "../create/ReviewSearch";
import { BiSolidEditAlt } from "react-icons/bi";
import AddImageSingle from "../imageUpload/AddImageSingle";
import LoginRegisterForm from "../auth/LoginRegisterForm";
import ReactPlayer from "react-player/youtube";

const ReviewList = (props) => {
  const [state, setState] = useState({
    open: false,
    editModalOpen: false,
    createModalOpen: false,
    searchModalOpen: false,
    imgModalOpen: false,
    path: "",
  });
  useEffect(() => {
    window.scroll(0, 0);
    props.fetchReviews({});
    window.scroll(0, 0);
  }, []);
  //^^^^^^^^^^^^^^^
  
  const show = (id, path) => {
    setState({ ...state, open: true, id: id, path: path });
  };

  //******************* */
  const handleConfirm = async () => {
    const did = state.id;
    const path = state.path;
    const imageURL = singleImageURL;
    //************
    try {
      // ^^^^^^^^^^
      const resImage = await axios.post(`${imageURL}/DeleteImage`, { path });
      //^^^^^^^^^^^^^^^^^
      if (resImage.data.msg === "success") {
        const res = await axios.put(`/api/ReviewDelete/${did}`);
        if (res.data.msg === "success") {
          const { offset, limit, } = props;
    const values = (props.form !== undefined && props.form.values) || {};
    
    props.fetchReviews(values,limit,offset);
          setState({ ...state, open: false });
          toastr.success("Deleted Successfully");
        }
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        console.log("error_deleteReview", error);
        toastr.error(
          "Oops",
          "Something went wrong.Please Try Again_deleteReview"
        );
      }
    }
    //**********
  };

  const handleCancel = () => setState({ ...state, open: false });
  //**********************************
  const handleEditModalOpen = (id) =>
    setState({ ...state, editModalOpen: true, id: id });
  const handleEditModalClose = () => {
    setState({ ...state, editModalOpen: false });
  }; //
  const handleEditModalCloseSubmit = () => {
    const { offset, limit, } = props;
    const values = (props.form !== undefined && props.form.values) || {};
    
    props.fetchReviews(values,limit,offset);
    setState({ ...state, editModalOpen: false });
  };
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  const handleSearchModalOpen = () =>
    setState({ ...state, searchModalOpen: true });
  const handleSearchModalClose = () => {
    setState({ ...state, searchModalOpen: false });
  }; //
  const handleSearchModalCloseSubmit = () => {
    props.fetchReviews({});
    setState({ ...state, searchModalOpen: false });
  };
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  const handleCreateModalOpen = () =>
    setState({ ...state, createModalOpen: true });
  const handleCreateModalClose = () =>
    setState({ ...state, createModalOpen: false });
    const handleCreateModalCloseSubmit = () => {
      props.fetchReviews({});
      setState({ ...state, createModalOpen: false });
    };
  const handleImgModalOpen = (id, img) =>
    setState({ ...state, imgModalOpen: true, id: id, path: img });
  const handleImgModalClose = () => {
    setState({ ...state, imgModalOpen: false });
  }; //
  const handleImgModalCloseSubmit = () => {
    const { offset, limit, } = props;
    const values = (props.form !== undefined && props.form.values) || {};
    
    props.fetchReviews(values,limit,offset);
    setState({ ...state, imgModalOpen: false });
  };

  const renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };
  // ******
  const days = (value) => {
    let duration = intervalToDuration({
      start: new Date(value),
      end: new Date(),
    });
    const units = [
      "years",
      "months",
      "weeks",
      "days",
      // "hours",
      // "minutes",
      // "seconds",
    ];
    const nonzero = Object.entries(duration)
      .filter(([value]) => value || 0 > 0)
      .map(([unit]) => unit);
    //const nonzero = Object.entries(duration).filter(([_, value]) => value || 0 > 0).map(([unit, _]) => unit)

    return formatDuration(duration, {
      format: units.filter((i) => new Set(nonzero).has(i)).slice(0, 5),
      delimiter: ", ",
    });
  };
  // ******

  //^^^^^^^^^^
  const advance = () => {
    const { offset, limit, count } = props;
    const values = (props.form !== undefined && props.form.values) || {};
    if (offset + limit > count) {
      return;
    }

    props.searchReviews(values, limit, offset + limit);
    // window.scroll(0, 0);
  };

  //^^^^^^^^^^
  const renderCreateButton = () => (
    <Popup className="index"
      content={"Write Review"}
      disabled={renderPopupState()}
      trigger={
        <span className="tag-cloud bt" onClick={() => handleCreateModalOpen()}>
          <BiSolidEditAlt />
          Write a Review
        </span>
      }
    />
  );
  //^^^^^^^^^^
  const renderSearchButton = () => (
    <Popup style={{zIndex:'10'}}
      content={"Search Review"}
      disabled={renderPopupState()}
      trigger={
        <span onClick={() => handleSearchModalOpen()}>
          <FaSearch
            className="icon-gr"
            style={{
              paddingLeft: "5px",
              paddingRight: "5px",
              backgroundColor: "dodgerblue",
            }}
          />
        </span>
      }
    />
  );

  // *****
  const renderListForAll = (reviews) => {
    const {
      userId,
      name,
      phone,
      rating,
      review,
      reviewReply,
      reviewType,
      videoPath,
      img,
      createdAt,
      _id,
    } = reviews;
    //******************
    const renderDeleteButton = () => (
      <Popup
        content={"Delete"}
        // disabled={renderPopupState()}
        trigger={
          <span onClick={() => show(_id, img)} className="">
            <RiDeleteBin5Line
              className="icon-gr"
              style={{ backgroundColor: "red" }}
            />
          </span>
        }
      />
    );
    //^^^^^^^^^^^
    const renderEditButton = () => (
      <Popup
        content={"Edit"}
        // disabled={renderPopupState()}
        trigger={
          <span onClick={() => handleEditModalOpen(_id)} className="">
            <FaRegEdit
              className="icon-gr"
              style={{ backgroundColor: "dodgerblue" }}
            />
          </span>
        }
      />
    );

    const renderAddImageButton = () => (
      <Popup
        content={"Add Image"}
        // disabled={renderPopupState()}
        trigger={
          <span onClick={() => handleImgModalOpen(_id, img)} className="">
            <RiImageAddLine
              className="icon-gr"
              style={{ backgroundColor: "skyblue" }}
            />
          </span>
        }
      />
    );
    //******************
    return (
      <div
        key={_id}
        className="card-review-all  direction-c"
        style={{ width: "100%", padding: "20px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            padding: "5px",
          }}
        >
          <div>
            {img && (
              <img
                className="img-border-bg imgDimention-review"
                src={`${imageDomain}${img}`}
              />
            )}
            {!img && (
              <span
                className="firstchar-card flex-center"
                style={{ backgroundColor: bgColor(5) }}
              >
                {name.charAt(0).toUpperCase()}
              </span>
            )}
          </div>
          <div style={{ marginLeft: "10px", paddingLeft: "10px" }}>
            <div className="font-20 textAlign-left">{name}</div>
            {/* {phone && <div className="font-16 textAlign-left">{phone}</div>} */}
            <div style={{ display: "flex" }}>
              {" "}
              {[...Array(rating)].map((e, i) => (
                <img key={i} src={`${imageDomain}/upload/mis/goldStar15.jpg`} />
              ))}
            </div>
            <div className="font-16 textAlign-left">
              {days(createdAt) ? `${days(createdAt)} ago` : "Today"}
            </div>
          </div>
        </div>
        <div>
          {reviewType === "Text" && <p className="font-16">{review}</p>}
          {reviewType === "Video" && (
            <div className="player-wrapper">
              <ReactPlayer
                light={true}
                //playing
                controls={true}
                className="react-player"
                url={videoPath}
                width="100%"
                height="100%"
              />
            </div>
          )}

          {/* review reply start */}
          {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            padding: "5px",
          }}
        >
          <div>
          <span   className="icon-button" >
              <img
                className="yimg "
                src="/logoGr.jpg"
                alt=" "
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          </div>
          <div style={{ marginLeft: "0px", padding: "0px" }}>
            <div className="font-20 textAlign-left">Gupta Realtors</div>
           
            <div className="font-16 textAlign-left">{days(createdAt)?`${days(createdAt)} ago` :'Today'}</div>
          </div>
        </div>
        {<p className="font-16">{reviewReply}</p>} */}
          {/* review reply end */}
        </div>
        <div className="mt-10 mb-10">
          {(userA.userType === "admin" ||
            userA.userType === "manager_dwk" ||
            userA.userType === "manager_ggn" ||
            (user && userId === user.id)) &&
            renderEditButton()}
          {(userA.userType === "admin" || (user && userId === user.id)) &&
            renderDeleteButton()}
          {(userA.userType === "admin" ||
            userA.userType === "manager_dwk" ||
            userA.userType === "manager_ggn" ||
            (user && userId === user.id)) &&
            renderAddImageButton()}
        </div>
      </div>
      // </div>
    );
  };

  const userA =
    props.userA !== undefined && props.userA !== null && props.userA;
  const { isAuthenticated } =
    props.state.auth !== undefined &&
    props.state.auth !== null &&
    props.state.auth;
  const user =
    props.state.auth !== undefined &&
    props.state.auth !== null &&
    props.state.auth.user !== null &&
    props.state.auth.user;

  //*************** */
  return (
    <div className="wraper-review-all">
      <div className="flex-center mt-20">{renderCreateButton()}</div>
      <div style={{ paddingLeft: "2rem" }} className="mt-20 font-18B">
        {renderSearchButton()} 
        <span style ={{paddingLeft:'2rem'}}>{props.count} Reviews</span>
      </div>
      <div className="flex-center">
        {props.state.reviews.reviews.map((item) => renderListForAll(item))}
        <br />
        <span className=" tag-cloud" style={{}} onClick={advance}>
          {props.offset + props.limit > props.count
            ? "No More Review"
            : "View More"}
        </span>
        <span
          className="ml-05 tag-cloud"
          style={{ color: "red" }}
          onClick={props.closeModal}
        >
          Close
        </span>
        <br />
        <br />
      </div>
      {/* img modal */}
      {state.imgModalOpen && (
        <ModalGr
          hasCloseBtn={true}
          isOpen={state.imgModalOpen}
          onClose={handleImgModalClose}
          className={"modal-review"}
        >
          <AddImageSingle
            handleImgModalClose={handleImgModalClose}
            id={state.id}
            path={state.path}
            handleImgModalCloseSubmit={handleImgModalCloseSubmit}
            hasDimention={false}
            height={150}
            width={150}
            folder={"review"}
            apiRoute={`/api/ReviewEditForAddImagePath`}
          />
        </ModalGr>
      )}
      <Confirm
        open={state.open}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />
      {/* create modal */}
      {state.createModalOpen && (
        <ModalGr
          hasCloseBtn={true}
          isOpen={state.createModalOpen}
          onClose={handleCreateModalClose}
          className={"modal-review body"}
        >
          {!isAuthenticated && (
            <LoginRegisterForm
              handleCreateModalClose={handleCreateModalClose}
            />
          )}
          {isAuthenticated && (
            <ReviewCreate
              handleCreateModalClose={handleCreateModalClose}
              handleCreateModalCloseSubmit={handleCreateModalCloseSubmit}
            />
          )}
        </ModalGr>
      )}
      {/* create Modal end*/}
      {/* Edit Modal*/}
      {state.editModalOpen && (
        <ModalGr
          hasCloseBtn={false}
          isOpen={state.editModalOpen}
          onClose={handleEditModalClose}
          className={"modal-review body"}
        >
          <ReviewEdit
            id={state.id}
            handleEditModalCloseSubmit={handleEditModalCloseSubmit}
            handleEditModalClose={handleEditModalClose}
          />
        </ModalGr>
      )}

      {/* edit Modal end*/}
      {/* search Modal*/}
      {state.searchModalOpen && (
        <ModalGr
          hasCloseBtn={false}
          isOpen={state.searchModalOpen}
          onClose={handleSearchModalClose}
          className={"modal-review body"}
        >
          <ReviewSearch
            handleSearchModalCloseSubmit={handleSearchModalCloseSubmit}
            handleSearchModalClose={handleSearchModalClose}
          />
        </ModalGr>
      )}

      {/* search Modal end*/}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { limit, offset, count } = state.reviews;

  return {
    auth: state.auth,
    userA: state.auth.userA,
    form: state.form.ReviewSearch,
    state,
    limit,
    offset,
    count,
  };
};

// export default ReviewList;
export default connect(mapStateToProps, { searchReviews, fetchReviews })(
  ReviewList
);
